import { createAPIService } from './api.service';

export const ME_ENDPOINT = '/user/api/v2/users/me';

const service = createAPIService(ME_ENDPOINT);
const tokenString = token => `Bearer ${token}`;

// endpoints
service.getCurrentUser = async token => {
  service.defaults.headers.authorization = tokenString(token);
  return (await service.get('')).data;
};

export default service;
